(function () {
  'use strict';

  // Jovellee editorial product slider
  if (window.__jovelleeEditorialProductSliderLoaded) return;
  window.__jovelleeEditorialProductSliderLoaded = true;

  var SELECTOR = '[data-bps-slider]';

  function toBoolean(value) {
    return value === true || value === 'true';
  }

  function EditorialProductSlider(root) {
    if (!root || root.__editorialProductSlider) return;

    this.root = root;
    this.editorialSlides = Array.prototype.slice.call(root.querySelectorAll('[data-bps-editorial-slide]'));
    this.productSlides = Array.prototype.slice.call(root.querySelectorAll('[data-bps-product-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-bps-dot]'));
    this.previousButtons = Array.prototype.slice.call(root.querySelectorAll('[data-bps-previous]'));
    this.nextButtons = Array.prototype.slice.call(root.querySelectorAll('[data-bps-next]'));
    this.cursor = root.querySelector('[data-bps-cursor]');
    this.cursorText = root.querySelector('[data-bps-cursor-text]');
    this.currentOutput = root.querySelector('[data-bps-current]');
    this.quickAddButtons = Array.prototype.slice.call(root.querySelectorAll('[data-bps-quick-add]'));
    this.quickViewModal = document.getElementById('BpsQuickview-' + root.dataset.sectionId);
    this.quickViewContent = this.quickViewModal ? this.quickViewModal.querySelector('[data-bps-quickview-content]') : null;
    this.count = Math.min(this.editorialSlides.length, this.productSlides.length);
    this.index = 0;
    this.timer = null;
    this.isHovering = false;
    this.isFocused = false;
    this.isVisible = true;
    this.autoplay = toBoolean(root.dataset.autoplay);
    this.pauseOnHover = toBoolean(root.dataset.pauseOnHover);
    this.delay = parseInt(root.dataset.delay, 10) || 5200;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
    this.touchStartX = null;

    root.__editorialProductSlider = this;

    if (this.count < 1) {
      root.classList.add('is-ready');
      return;
    }

    this.bindEvents();
    this.goTo(0, false);
    this.observeVisibility();

    window.requestAnimationFrame(function () {
      root.classList.add('is-ready');
    });
  }

  EditorialProductSlider.prototype.bindEvents = function () {
    var self = this;
    var options = { signal: this.signal };

    this.root.addEventListener('click', function (event) {
      var prevButton = event.target.closest('[data-bps-previous]');
      var nextButton = event.target.closest('[data-bps-next]');

      if (prevButton && self.root.contains(prevButton)) {
        event.preventDefault();
        event.stopPropagation();
        self.previous(true);
        return;
      }

      if (nextButton && self.root.contains(nextButton)) {
        event.preventDefault();
        event.stopPropagation();
        self.next(true);
      }
    }, options);

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.goTo(parseInt(dot.dataset.bpsDot, 10), true);
      }, options);
    });

    this.quickAddButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.openQuickView(button);
      }, options);
    });

    this.root.querySelectorAll('.bps__nav-zone').forEach(function (zone) {
      zone.addEventListener('mouseenter', function () {
        if (!self.cursor || !self.cursorText) return;
        self.cursorText.textContent = zone.dataset.bpsCursorLabel || '';
        self.root.classList.add('is-cursor-visible');
      }, options);

      zone.addEventListener('mousemove', function (event) {
        if (!self.cursor) return;
        self.cursor.style.left = event.clientX + 'px';
        self.cursor.style.top = event.clientY + 'px';
      }, options);

      zone.addEventListener('mouseleave', function () {
        self.root.classList.remove('is-cursor-visible');
      }, options);
    });

    if (this.pauseOnHover) {
      this.root.addEventListener('mouseenter', function () {
        self.isHovering = true;
        self.stopTimer();
      }, options);

      this.root.addEventListener('mouseleave', function () {
        self.isHovering = false;
        self.startTimer();
      }, options);
    }

    this.root.addEventListener('focusin', function () {
      self.isFocused = true;
      self.stopTimer();
    }, options);

    this.root.addEventListener('focusout', function (event) {
      if (self.root.contains(event.relatedTarget)) return;
      self.isFocused = false;
      self.startTimer();
    }, options);

    this.root.addEventListener('keydown', function (event) {
      if (event.target.matches('input, select, textarea')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.previous(true);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.next(true);
      }
    }, options);

    this.root.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      if (event.target.closest('a, button, input, select, textarea')) return;
      self.touchStartX = event.touches[0].clientX;
    }, { passive: true, signal: this.signal });

    this.root.addEventListener('touchend', function (event) {
      if (self.touchStartX === null || !event.changedTouches || !event.changedTouches.length) return;
      var distance = event.changedTouches[0].clientX - self.touchStartX;
      self.touchStartX = null;
      if (Math.abs(distance) < 45) return;
      if (distance > 0) self.previous(true);
      else self.next(true);
    }, { passive: true, signal: this.signal });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.stopTimer();
      else self.startTimer();
    }, options);
  };

  EditorialProductSlider.prototype.observeVisibility = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) {
      this.startTimer();
      return;
    }

    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target !== self.root) return;
        self.isVisible = entry.isIntersecting && entry.intersectionRatio > 0.1;
        if (self.isVisible) self.startTimer();
        else self.stopTimer();
      });
    }, { threshold: [0, 0.1, 0.5] });

    this.observer.observe(this.root);
  };

  EditorialProductSlider.prototype.setFocusableState = function (slide, active) {
    if (!slide) return;
    slide.querySelectorAll('a, button, input, select, textarea').forEach(function (element) {
      if (active) element.removeAttribute('tabindex');
      else element.setAttribute('tabindex', '-1');
    });
  };

  EditorialProductSlider.prototype.updateSlides = function (slides, activeIndex) {
    var count = slides.length;
    var self = this;

    slides.forEach(function (slide, index) {
      var distance = (index - activeIndex + count) % count;
      var active = distance === 0;
      var before = !active && distance > count / 2;

      slide.classList.toggle('is-active', active);
      slide.classList.toggle('is-before', before);
      slide.classList.toggle('is-after', !active && !before);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      self.setFocusableState(slide, active);
    });
  };

  EditorialProductSlider.prototype.goTo = function (targetIndex, userInitiated) {
    if (this.count < 1 || Number.isNaN(targetIndex)) return;

    this.index = (targetIndex % this.count + this.count) % this.count;
    this.updateSlides(this.editorialSlides, this.index);
    this.updateSlides(this.productSlides, this.index);

    this.dots.forEach(function (dot, index) {
      var active = index === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    }, this);

    if (this.currentOutput) this.currentOutput.textContent = String(this.index + 1);
    this.root.dataset.activeSlide = String(this.index);

    if (userInitiated) {
      this.stopTimer();
      this.startTimer();
    } else {
      this.startTimer();
    }
  };

  EditorialProductSlider.prototype.previous = function (userInitiated) {
    this.goTo(this.index - 1, userInitiated);
  };

  EditorialProductSlider.prototype.next = function (userInitiated) {
    this.goTo(this.index + 1, userInitiated);
  };

  EditorialProductSlider.prototype.canAutoplay = function () {
    return this.autoplay &&
      !this.reduceMotion &&
      this.count > 1 &&
      this.isVisible &&
      !document.hidden &&
      !this.isHovering &&
      !this.isFocused;
  };

  EditorialProductSlider.prototype.startTimer = function () {
    var self = this;
    this.stopTimer();
    if (!this.canAutoplay()) return;

    this.timer = window.setTimeout(function () {
      self.next(false);
    }, this.delay);
  };

  EditorialProductSlider.prototype.stopTimer = function () {
    if (!this.timer) return;
    window.clearTimeout(this.timer);
    this.timer = null;
  };

  EditorialProductSlider.prototype.selectBlock = function (blockId) {
    if (!blockId) return;
    var slide = this.root.querySelector('[data-bps-product-slide][data-bps-block-id="' + blockId + '"]');
    if (!slide) return;
    this.stopTimer();
    this.goTo(parseInt(slide.dataset.bpsIndex, 10), false);
  };

  EditorialProductSlider.prototype.showQuickViewModal = function () {
    if (!this.quickViewModal) return;
    if (typeof this.quickViewModal.showPopover === 'function') {
      if (!this.quickViewModal.matches(':popover-open')) this.quickViewModal.showPopover();
    } else {
      this.quickViewModal.classList.add('modal--active');
    }
  };

  EditorialProductSlider.prototype.hideQuickViewModal = function () {
    if (!this.quickViewModal) return;
    if (typeof this.quickViewModal.hidePopover === 'function') {
      if (this.quickViewModal.matches(':popover-open')) this.quickViewModal.hidePopover();
    } else {
      this.quickViewModal.classList.remove('modal--active');
    }
  };

  EditorialProductSlider.prototype.openQuickView = function (button) {
    var self = this;
    var productUrl = button.dataset.productUrl;
    if (!productUrl || !this.quickViewModal || !this.quickViewContent) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    this.quickViewContent.innerHTML = '<div class="loading-wrapper"><p>Loading...</p></div>';
    this.showQuickViewModal();

    fetch(productUrl.split('?')[0] + '?view=quick', { signal: this.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Quickview request failed');
        return response.text();
      })
      .then(function (htmlText) {
        var parsed = new DOMParser().parseFromString(htmlText, 'text/html');
        var template = parsed.querySelector('[data-html="content"]');
        if (!template) throw new Error('Quickview content missing');

        self.quickViewContent.innerHTML = template.innerHTML;
        var context = self.quickViewContent.querySelector('.js-quickview-wrapper');
        if (!context) throw new Error('Quickview product missing');

        if (window.theme && typeof window.theme.Product === 'function') {
          window.theme.Product(context);
        }

        if (context.dataset.paymentButton === 'true' && window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        var submit = context.querySelector('.js-ajax-submit');
        if (submit) {
          submit.addEventListener('click', function (event) {
            event.preventDefault();
            var form = submit.closest('form');
            var cartConfigElement = document.getElementById('cart-config');
            if (!form || !cartConfigElement || !window.Shopify || !Shopify.theme || !Shopify.theme.ajaxCart) return;

            var cartConfig = JSON.parse(cartConfigElement.innerHTML || '{}');
            self.hideQuickViewModal();
            Shopify.theme.ajaxCart.addToCart(form, submit.parentNode, cartConfig, false);
          }, { signal: self.signal });
        }
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        self.quickViewContent.innerHTML = '<p class="bps-quickview__error">Unable to load options. <a href="' + productUrl + '">View product</a></p>';
      })
      .finally(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  };

  EditorialProductSlider.prototype.destroy = function () {
    this.stopTimer();
    this.hideQuickViewModal();
    if (this.observer) this.observer.disconnect();
    this.abortController.abort();
    this.root.__editorialProductSlider = null;
  };

  function init(scope) {
    var context = scope || document;
    var roots = [];

    if (context.matches && context.matches(SELECTOR)) roots.push(context);
    if (context.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(context.querySelectorAll(SELECTOR)));
    }

    roots.forEach(function (root) {
      if (!root.__editorialProductSlider) new EditorialProductSlider(root);
    });
  }

  function boot() {
    init(document);

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector ? event.target.querySelector(SELECTOR) : null;
      if (root && root.__editorialProductSlider) root.__editorialProductSlider.destroy();
    });

    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest ? event.target.closest(SELECTOR) : null;
      if (!root || !root.__editorialProductSlider) return;
      root.__editorialProductSlider.selectBlock(event.detail && event.detail.blockId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
